import { NudgeLibraryEntry } from './nudge-library-port.service';

export interface LibraryNudgeSource extends Omit<NudgeLibraryEntry, 'target' | 'incentiveID' | 'screenshot'> {
  sourceTarget: string;
  incentiveId: string;
  observations: number;
}

/** A screenshot always belongs to the selected source client; never use another client as fallback. */
export function libraryScreenshotUrl(nudge: {sourceTarget: string; incentiveId: string; preview?: {target?: string; isReference?: boolean}}, platform: 'mobile' | 'desktop' = 'mobile'): string {
  const target = nudge.preview?.target || nudge.sourceTarget;
  if (nudge.preview?.isReference || !target || !nudge.incentiveId) return '';
  return `https://behamicsfront.blob.core.windows.net/clients-screenshots/${encodeURIComponent(target)}/${platform}/${encodeURIComponent(nudge.incentiveId)}.jpeg`;
}

/** Both library selection and Explore send the same source content and mobile screenshot. */
export function buildNudgeLibraryEntry(nudge: LibraryNudgeSource): NudgeLibraryEntry {
  return {
    target: nudge.sourceTarget,
    incentiveID: nudge.incentiveId,
    screenshot: libraryScreenshotUrl(nudge),
    html: nudge.html || '',
    devices: [...(nudge.devices || [])],
    title: nudge.title,
    copy: nudge.copy,
    description: nudge.description,
    effect: nudge.effect,
    pattern: nudge.pattern,
    placement: nudge.placement,
    incentiveType: nudge.incentiveType,
    sector: nudge.sector,
    primaryKpi: nudge.primaryKpi,
  };
}
